import { render } from "./RegistrationView.vue?vue&type=template&id=58002dec&scoped=true"
import script from "./RegistrationView.vue?vue&type=script&lang=js"
export * from "./RegistrationView.vue?vue&type=script&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=58002dec&scoped=true&lang=css"

import exportComponent from "d:\\projekty\\www\\cdif3com\\rental\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58002dec"]])

export default __exports__